import { render } from "./Home.vue?vue&type=template&id=3f3900dc&scoped=true&%C3%89=true&s%C3%B3=true&ligarv-on%3Ascrol=handleScroll()"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3f3900dc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\ijrmudancasecarretos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3900dc"]])

export default __exports__